import * as React from 'react';
import styled from 'styled-components';
import { RepAprTerm } from './RepAprTerm';
import { RepAprAmount } from './RepAprAmount';
import { grid } from '@zopauk/react-components';

const CalculatorContainer = styled.div`
  max-width: 100%;
  padding-top: 40px;

  @media (min-width: ${grid.breakpoints.m}px) {
    max-width: 50%;
  }
`;

type RepAprCalculatorProps = {
  setAmount: (value: number) => void;
  setTerm: (value: number) => void;
  amount: number;
  term: number;
};

export function RepAprCalculator({ setAmount, setTerm, amount, term }: RepAprCalculatorProps) {
  return (
    <>
      <CalculatorContainer>
        <RepAprAmount onChange={setAmount} value={amount} />
        <RepAprTerm onChange={setTerm} value={term} />
      </CalculatorContainer>
    </>
  );
}
